import { render, staticRenderFns } from "./SingleCampaign.vue?vue&type=template&id=2e36e28a&scoped=true"
import script from "./SingleCampaign.vue?vue&type=script&lang=js"
export * from "./SingleCampaign.vue?vue&type=script&lang=js"
import style0 from "./SingleCampaign.vue?vue&type=style&index=0&id=2e36e28a&prod&lang=scss"
import style1 from "./SingleCampaign.vue?vue&type=style&index=1&id=2e36e28a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e36e28a",
  null
  
)

export default component.exports